import { FC, ReactNode } from 'react';

import { Divider, Flex, Group, Stack, Text } from '@mantine/core';

import { useIsMobile } from 'hooks/use-is-mobile';

import cx from './BadgeGroup.module.scss';

export const BadgeGroup: FC<{ label?: string; withDivider?: boolean; children: ReactNode }> = ({
    label,
    withDivider = true,
    children,
}) => {
    const isMobile = useIsMobile('sm');

    if (isMobile) {
        return (
            <Group className={cx.row} align="flex-start" wrap="nowrap" gap="md">
                <Text fz="xs" c="dimmed" className={cx.rowLabel}>
                    {label}
                </Text>
                <Group gap={4}>{children}</Group>
            </Group>
        );
    }

    return (
        <Flex className={cx.group} gap="xs">
            {withDivider && (
                <Divider
                    className={cx.divider}
                    visibleFrom="xs"
                    orientation="vertical"
                    size={2}
                    h={34}
                    style={{ alignSelf: 'end' }}
                />
            )}
            <Stack gap={4}>
                {label && (
                    <Text fw={500} fz="sm">
                        {label}
                    </Text>
                )}
                {children}
            </Stack>
        </Flex>
    );
};
